import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, lambda_type, unit_type, bool_type, string_type, list_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { ofArrayWithTail, ofArray, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { classNames } from "../../Utils.js";
import { flatpickr, ClassName, Disabled } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { getWrappedMaterialIcon } from "../../ViewUtils.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Components/StatefulFormFields/Common.scss";


export class DatepickerProps extends Record {
    constructor(FlatpickrOptions, LabelText, ShowIcon, Disabled, OnClearClick) {
        super();
        this.FlatpickrOptions = FlatpickrOptions;
        this.LabelText = LabelText;
        this.ShowIcon = ShowIcon;
        this.Disabled = Disabled;
        this.OnClearClick = OnClearClick;
    }
}

export function DatepickerProps$reflection() {
    return record_type("Components.StatefulFormFields.Datepicker.DatepickerProps", [], DatepickerProps, () => [["FlatpickrOptions", list_type(class_type("Flatpickr.IFlatpickrOption"))], ["LabelText", string_type], ["ShowIcon", bool_type], ["Disabled", bool_type], ["OnClearClick", option_type(lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type))]]);
}

export function DatepickerProps_get_getDefault() {
    return new DatepickerProps(empty(), "", false, false, void 0);
}

export const DatePicker = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_6;
    const isClearedState = react.useState(false);
    let key;
    const matchValue = isClearedState[0];
    key = (matchValue ? "datepicker-cleared-2" : "datepicker-cleared-1");
    const inputContainerClasses = classNames(ofArray([["input-container", true], ["input-container--disabled", props.Disabled]]));
    const flatpickrClasses = classNames(ofArray([["input__date", true], ["input__date--with-icon", props.ShowIcon]]));
    const augmentedOptions = ofArrayWithTail([props.Disabled ? Disabled(true) : Disabled(false), ClassName(flatpickrClasses)], props.FlatpickrOptions);
    const labelHtml = (props.LabelText !== "") ? react.createElement("span", {
        className: "input__date-label",
    }, props.LabelText) : react.createElement(react.Fragment, {});
    let clearIconHtml;
    const matchValue_1 = props.OnClearClick;
    if (matchValue_1 != null) {
        const onClearClick = matchValue_1;
        const children_4 = [getWrappedMaterialIcon("close")];
        clearIconHtml = react.createElement("div", {
            className: "input__cross-icon",
            onClick: (arg) => {
                isClearedState[1]((value) => (!value));
                onClearClick(arg);
            },
        }, ...children_4);
    }
    else {
        clearIconHtml = react.createElement(react.Fragment, {});
    }
    const children_9 = [props.ShowIcon ? ((children_6 = [getWrappedMaterialIcon("date_range")], react.createElement("div", {
        className: "input__date-icon",
    }, ...children_6))) : react.createElement(react.Fragment, {}), flatpickr(augmentedOptions), clearIconHtml, labelHtml];
    return react.createElement("div", {
        className: inputContainerClasses,
        key: key,
    }, ...children_9);
}, void 0, uncurry(2, void 0), void 0, "DatePicker", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\StatefulFormFields\\Datepicker.fs", 73);

